// src/services/adminUserService.js
import { apiRequest } from '../api/client';
import { endpoints } from '../api/endpoints';

export function getAllUsers() {
    return apiRequest(endpoints.AdminGetAllUsers, {
        method: 'GET',
    });
}

export function fetchUsersPage(page = 0, size = 25) {
    const url = new URL(endpoints.AdminGetUsersPage, window.location.origin);
    url.searchParams.append('page', page);
    url.searchParams.append('size', size);
    return apiRequest(url.toString(), {
        method: 'GET',
    });
}

export function deleteUser(id) {
    return apiRequest(endpoints.AdminDeleteUser(id), {
        method: 'DELETE',
    });
}

export function updateUserRole(id, role) {
    return apiRequest(endpoints.AdminUpdateUserRole(id), {
        method: 'PUT',
        body: JSON.stringify({ role }),
    });
}

export function toggleUserEnabled(id) {
    return apiRequest(endpoints.AdminToggleUserEnabled(id), {
        method: 'PUT',
    });
}
